<!-- 订单详情 -->
<template>
	<div class="wrap">

		<div class="middle-container">
			<p class="middle-container-top">{{ titleMap[info.order_status] || '订单详情' }}</p>


			<div class="address-module">
				<p class="address-module-title">收货地址</p>
				<ul class="address-module-list">
					<li>
						<span class="user-name">{{ info.name }}</span>
						<span class="addrss-msg">{{ info.full_address }} </span>
						<span class="user-number">{{ info.mobile }}</span>
					</li>
				</ul>
			</div>

			<div class="item-module" v-for="(item, index) in info.order_goods" :key="index">
				<div class="item-big">
					<div class="msg-module">
						<img :src="BASE_URL + item.sku_image" class="produt-img">
						<div class="msg-module-sidebar">
							<p class="produt-title">{{ item.sku_name }}</p>
							<p class="produt-tag">支持7天无理由退换货</p>
						</div>
					</div>
				</div>
				<div class="produt-msg-box">
					<p class="produt-msg" v-for="(item2, index2) in item.sku_spec_format" :key="index2">
            {{ item2.spec_name }}：{{ item2.spec_value_name }}
          </p>
<!--					<p class="produt-msg">尺码：37寸</p>-->
				</div>
				<div class="price-box">
					<span class="produt-price">¥ {{ item.price }}</span>
					<span class="produt-price-del">¥ {{ item.cost_price }}</span>
				</div>
				<div class="calc-box">
					<span class="calc-num">{{ item.num }}</span>
				</div>
				<div class="total-price-box">
					<span class="font-1">¥ {{ item.goods_money }}</span>
					<span class="font-2">（运费:{{ info.delivery_money }}）</span>
				</div>
			</div>


			<div class="price-module">
				<p class="price-module-label">价格明细</p>
				<div class="price-module-between">
					<span class="font-6">商品总价(共{{ info.goods_num }}件宝贝)</span>
					<span class="font-6">¥{{ info.goods_money }}</span>
				</div>
				<div class="price-module-between" v-if="parseFloat(info.discount) < 10">
					<div class="row-1">
						<img src="../assets/tag-5.png">{{ info.discount_name }}
					</div>
					<div class="row-2">
						特享折扣<span> {{ info.discount }}</span>折
					</div>
				</div>
        <div class="price-module-between">
          <span class="font-6">运费</span>
          <span class="font-6">¥{{ info.delivery_money || '0.00' }}</span>
        </div>
        <div class="price-module-between">
					<span class="font-7">实付款</span>
					<span class="font-8">¥{{ info.pay_money }}</span>
				</div>
			</div>

			<div class="order-msg-module">
				<p class="order-msg-label">订单详情</p>
				<p class="order-number">订单编号:{{ info.order_no }}</p>
				<ul class="timeline">
					<li>
						<span class="font-9">创建时间</span>
						<span class="circle-row"></span>
						<span class="font-10">{{ info.create_time }}</span>
					</li>
					<li :class="{null: !info.pay_time}">
						<span class="font-9">付款时间</span>
						<span class="circle-row"></span>
						<span class="font-10">{{ info.pay_time || '暂未付款' }}</span>
					</li>
					<li :class="{null: !info.delivery_time}">
						<span class="font-9">发货时间</span>
						<span class="circle-row"></span>
            <span class="font-10">{{ info.delivery_time || '暂未发货' }}</span>
					</li>
					<li :class="{null: !info.sign_time}">
						<span class="font-9">成交时间</span>
						<span class="circle-row"></span>
            <span class="font-10">{{ info.sign_time || '暂未完成' }}</span>
					</li>
				</ul>
			</div>

<!--			<div class="order-msg-module">-->
<!--				<p class="order-msg-label">物流信息</p>-->
<!--				<ul class="timeline">-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							<span>圆通快递派送</span>-->
<!--							<span>单号：<b>15464546465</b></span>-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							广东省深圳市宝安区-->
<!--							[咚呛公司]-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							广东省深圳市宝安区-->
<!--							[咚呛公司]-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							广东省深圳市宝安区-->
<!--							[咚呛公司]-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							广东省深圳市宝安区-->
<!--							[咚呛公司]-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							广东省深圳市宝安区-->
<!--							[咚呛公司]-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--					<li>-->
<!--						<span class="font-9">快递已揽收</span>-->
<!--						<span class="circle-row"></span>-->
<!--						<p class="timeline-row">-->
<!--							广东省深圳市宝安区-->
<!--							[咚呛公司]-->
<!--						</p>-->
<!--						<span class="font-10">2022-06-08 09:44:15</span>-->
<!--					</li>-->
<!--				</ul>-->
<!--			</div>-->

			<div class="order-msg-module" v-if="info.order_status === 0">
				<p class="order-msg-label">支付方式</p>
				<ul class="pay-type-list">
          <li @click="payParams.pay_type = 'alipay'" :class="{active: payParams.pay_type === 'alipay'}">
            <img src="../assets/pay-2.png">
            支付宝支付
          </li>
          <li @click="payParams.pay_type = 'wechatpay'" :class="{active: payParams.pay_type === 'wechatpay'}">
            <img src="../assets/pay-1.png">
            微信支付
          </li>
          <li @click="payParams.pay_type = 'BALANCE'" :class="{active: payParams.pay_type === 'BALANCE'}">
            <img src="../assets/pay-4.png">
            余额支付
          </li>
          <li @click="Message.warning('暂不支持')"><img src="../assets/pay-3.png">银联支付</li>
				</ul>
			</div>

			<div class="btn-box-end" v-if="info.refundNum === 0">
				<button type="button" @click="$router.back()">返回</button>
				<button v-if="info.order_status === 0" type="button" @click="pay(info.order_id, info.pay_money)">提交订单</button>
        <button v-if="info.order_status === 3" type="button" @click="takeDelivery(info.order_id)">确认收货</button>
				<button v-if="info.order_status === 4 && info.evaluate_status === 0" type="button" @click="$router.push(`/evaluate?id=${info.order_id}`)">评价</button>
			</div>
      <div class="btn-box-end" v-else>
        <button type="button" @click="$router.back()">返回</button>
      </div>

		</div>

    <ali-wechat-pay ref="aliWechatPay" @success="getInfo()" />

	</div>
</template>

<script>
	import {OrderService} from "@/common/service";
  import {BASE_URL} from "@/common/config";
  import {Message, MessageBox} from "element-ui";
  import dayjs from "dayjs";
  import AliWechatPay from "@/components/ali-wechat-pay";

  export default {
    components: {AliWechatPay},
    data() {
			return {
        Message,
        BASE_URL,

        titleMap: {
          0: '等待卖家付款', // 订单代付款
          1: '等待卖家发货', // 订单已支付代发货
          3: '正在运输中', // 订单已发货
          4: '交易完成', // 订单已收货
        },

        id: 0,
        info: {},

        payParams: {
          pay_type: 'BALANCE', // BALANCE 余额支付 微信支付 wechatpay 支付宝支付 alipay
          order_id: '',
          pay_money: '',
        },
			};
		},
		mounted() {
      const option = this.$route.query;
      this.id = parseInt(option.id || 0);
      if (this.id > 0) {
        this.getInfo();
      }
    },
		methods: {
      // 支付
      pay() {
        const params = this.payParams;
        if (params.pay_type === 'BALANCE') {
          OrderService.order_pay(params).then(({message}) => {
            Message.success(message);
            this.getInfo();
          });
        } else {
          this.$refs['aliWechatPay'].pay({
            pay_type: params.pay_type,
            out_trade_no: this.info.out_trade_no,
            return_url: location.href,
          });
        }
      },
      // pay(order_id, pay_money) {
      //   OrderService.order_pay({
      //     order_id,
      //     pay_money,
      //     pay_type: 'BALANCE',
      //   }).then(({message}) => {
      //     Message.success(message);
      //     this.getInfo();
      //   });
      // },
      // 确认收货
      takeDelivery(order_id) {
        MessageBox({
          type: 'warning',
          title: '提示',
          message: '确定确认收货？',
          showCancelButton: true,
        }).then(() => {
          OrderService.takeDelivery({order_id}).then(({message}) => {
            Message.success(message);
            this.getInfo();
          });
        });
      },
      getInfo() {
        OrderService.detail({order_id: this.id}).then(({data}) => {
          const time = new Date('2000-01-01 00:00:00').getTime();
          data.pay_time = new Date(data.pay_time).getTime() < time ? '' : data.pay_time;
          data.delivery_time = new Date(data.delivery_time).getTime() < time ? '' : data.delivery_time;
          data.finish_time = new Date(data.finish_time).getTime() < time ? '' : data.finish_time;
          data.sign_time = !!data.sign_time ? dayjs.unix(parseFloat(data.sign_time), 'X').format('YYYY-MM-DD HH:mm:ss') : '';
          // data.sign_time = new Date(data.sign_time).getTime() < time ? '' : data.sign_time;

          let isAllRefund = true;
          let refundNum = 0;
          data.order_goods.forEach(item => {
            if (typeof item.sku_spec_format === 'string') {
              item.sku_spec_format = JSON.parse(item.sku_spec_format || '[]');
            }
            if (isAllRefund && item.refund_status === 0) {
              isAllRefund = false;
            }
            if (item.refund_status > 0) {
              refundNum += 1;
            }
          });

          this.info = data;
          this.payParams.order_id = data.order_id;
          this.payParams.pay_money = data.pay_money;
        }).finally(() => {
          console.log(JSON.stringify(this.info, null,2));
        });
      },
    },
	};
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.middle-container {
		width: 100%;
		min-height: calc(100vh - 314px);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.footer {
		width: 100%;
		height: 271px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.footer-middle {
		width: calc(1200px - 292px);
		display: flex;
		flex-direction: column;
	}

	.footer-tag-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-tag-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.footer-tag-icon {
		width: 56px;
		margin-bottom: 14px;
	}

	.footer-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px;
		box-sizing: border-box;
		margin-top: 37px;
	}

	.footer-bottom-left {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 135px;
	}

	.footer-bottom-left-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.footer-bottom-left-list>li {
		width: 33.3333%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 16px;
		font-weight: bold;
		margin-top: 15px;
	}

	.footer-bottom-left-list>li:first-child,
	.footer-bottom-left-list>li:nth-child(2),
	.footer-bottom-left-list>li:nth-child(3) {
		margin-top: 0;
	}

	.footer-bottom-right {
		display: flex;
		align-items: center;
	}

	.footer-bottom-right-img {
		width: 48px;
		margin-right: 7px;
	}

	.footer-bottom-right-row {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.footer-font1 {
		color: #C69236;
		font-size: 28px;
		font-weight: bold;
	}

	.footer-font2 {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.middle-container {
		width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.middle-container-top {
		width: 100%;
		height: 41px;
		line-height: 41px;
		display: flex;
		align-items: center;
    /*background: linear-gradient(180deg, #F3DC99, #F0AE46);*/
    background: #FFEC8B;
		padding: 0 30px;
		box-sizing: border-box;
		font-size: 18px;
		/*color: #FFFFFF;*/
    color: #CD3333;
		font-weight: bold;
		margin-bottom: 10px;
		margin-top: 26px;
		border-radius: 12px 12px 0 0;
	}

	.address-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 21px 30px;
		box-sizing: border-box;
		border-radius: 4px;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}

	.address-module-title {
		width: 100%;
		color: #333333;
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.address-module-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-left: 32px;
		box-sizing: border-box;
	}

	.address-module-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.address-module-list>li:last-child {
		margin-bottom: 0;
	}

	.user-name {
		width: 133px;
		color: #333333;
		font-size: 16px;
	}

	.addrss-msg {
		width: 383px;
		color: #333333;
		font-size: 16px;
	}

	.user-number {
		color: #333333;
		font-size: 16px;
	}

	.item-module {
		width: 100%;
		display: flex;
		align-items: center;
		border-radius: 4px;
		padding: 30px 42px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}

	.item-big {
		width: calc(100% - 738px);
		display: flex;
		align-items: center;
	}

	.circle-box {
		width: 83px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.circle-img {
		width: 16px;
	}

	.msg-module {

		display: flex;
		align-items: center;
	}

	.produt-img {
		width: 120px;
		height: 120px;
		display: flex;
		align-items: center;
		margin-right: 15px;
	}

	.msg-module-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.produt-title {
		width: 145px;
		color: #333333;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 9px;
	}

	.produt-msg {
		color: #333333;
		font-size: 16px;
	}

	.produt-tag {
		color: #FF6619;
		font-size: 12px;
		margin-top: 9px;
	}

	.produt-msg-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.price-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.produt-price {
		color: #333333;
		font-size: 18px;
		font-weight: bold;
	}

	.produt-price-del {
		color: #999999;
		font-size: 12px;
		font-weight: bold;
		text-decoration: line-through;
		margin-top: 5px;
	}

	.calc-box {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.commodity-operation {
		width: 123px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.operation {
		color: #666666;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.operation:last-child {
		margin-bottom: 0;
	}

	.order-status {
		width: 123px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.status {
		color: #666666;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.status:last-child {
		margin-bottom: 0;
	}

	.status.orange {
		color: #FF6619;
	}

	.calc-wrap {
		width: 71px;
		display: flex;
		align-items: center;
		border: 1px solid #999999;
		border-radius: 8px;
	}

	.calc-wrap>button {
		width: 19px;
		height: 22px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.calc-wrap>button>img {
		width: 16px;
	}

	.calc-wrap>input {
		width: 33px;
		height: 22px;
		line-height: 22px;
		font-size: 14px;
		font-weight: bold;
		color: #333333;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		border-left: 1px solid #999999;
		border-right: 1px solid #999999;
		box-sizing: border-box;
	}

	.total-price-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.font-1 {
		color: #FF6619;
		font-size: 18px;
		font-weight: bold;
	}

	.font-2 {
		color: #333333;
		font-size: 12px;
		margin-top: 1px;
	}

	.calc-num {
		color: #333333;
		font-size: 18px;
		font-weight: bold;
	}

	.price-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 13px 42px 22px;
		box-sizing: border-box;
	}

	.price-module-label {
		width: 100%;
		color: #333333;
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.price-module-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.price-module-between:last-child {
		margin-bottom: 0;
	}

	.font-6 {
		color: #333333;
		font-size: 18px;
	}

	.row-1 {
		display: flex;
		align-items: center;
		color: #AB6200;
		font-size: 18px;
	}

	.row-1>img {
		width: 24px;
		margin-right: 11px;
	}

	.row-2 {
		color: #333333;
		font-size: 18px;
	}

	.row-2>span {
		color: #F37C3D;
		font-weight: bold;
	}

	.font-7 {
		color: #333333;
		font-size: 18px;
		font-weight: bold;
	}

	.font-8 {
		color: #FF6619;
		font-size: 18px;
		font-weight: bold;
	}

	.btn-box-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 17px 0 27px;
	}

	.btn-box-end>button {
		width: 131px;
		height: 52px;
		line-height: 52px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
		background-color: #FF6619;
		color: #FFFFFF;
		font-size: 20px;
		margin-right: 59px;
	}

	.btn-box-end>button:last-child {
		margin-right: 0;
	}

	.order-msg-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		padding: 13px 42px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.order-msg-label {
		width: 100%;
		color: #333333;
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.order-number {
		width: 100%;
		color: #333333;
		font-size: 16px;
		margin-bottom: 13px;
	}

	.timeline {
		width: 100%;
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
	}

	.timeline>li {
		width: 146px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		color: #333333;
		font-size: 16px;
		margin-bottom: 15px;
	}

	.timeline>li::after {
		content: "";
		width: 100%;
		height: 2px;
		background-color: #FF6619;
		position: absolute;
		right: -50%;
		top: 34.5px;
		transform: translate(0, -50%);
	}

	.timeline>li:last-child {
		margin-right: 0;
	}

	.circle-row {
		width: 17px;
		height: 17px;
		border-radius: 50%;
		background-color: #FF6619;
		z-index: 100;
	}

  .timeline>li.null::after,
  .timeline>li.null .circle-row{
    background-color: #b2b2b2;
  }

  .timeline>li:last-child::after {
    background-color: initial;
  }

	.font-9 {
		height: 26px;
		line-height: 26px;
	}

	.timeline-row {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #333333;
		padding: 5px 0;
	}

	.font-10 {
		text-align: center;
		color: #333333;
		font-size: 16px;
	}

	.pay-type-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.pay-type-list>li {
		width: fit-content;
		min-width: 147px;
		padding: 0 17px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #999999;
		border-radius: 4px;
		margin-right: 50px;
		color: #333333;
		font-size: 14px;
		background: #FFFFFF;
		box-sizing: border-box;
	}

	.pay-type-list>li>img {
		width: 35px;
		margin-right: 12px;
	}

	.pay-type-list>li.active {
		background: rgba(243, 124, 61, 0.15);
		border: 1px solid #FF6619;
	}
</style>
